/* eslint-disable eqeqeq */
/* eslint-disable no-console */
import React, { memo } from "react";
import { Row, Col } from "antd";

const InvitationExpiredScreen = () => {
  return (
    <div className="w-screen h-screen">
      <Row className="h-full">
        <Col span={15} className="h-full overflow-hidden">
          <img
            src="/assets/images/Login/login-image-new.png"
            alt="LoginImage"
            className="object-cover w-full h-full"
          />
        </Col>

        <Col span={9}>
          <div className="flex flex-col items-center justify-center w-full h-full gap-y-6 bg-background-white">
            <img
              // src="/assets/songa-main-logo.svg"
              src="/assets/songa-main-logo-4x.png"
              alt="Songa Mobility"
              className="w-[258px] h-14"
            />

            <div>
              <p className="font-poppins text-base font-medium text-center capitalize">
                Uh Oh!
              </p>

              <p className="mt-2 font-poppins text-xs font-light text-center text-dark-gray">
                Your invitation link has expired.
              </p>
              <p className="mt-0.5 font-poppins text-xs font-light text-center text-dark-gray">
                Please ask your admin to invite you again.
              </p>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};
export default memo(InvitationExpiredScreen);
